import React from "react";
import { Grid } from "@material-ui/core";
import { Mutation } from "react-apollo";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import UPDATE_CHEF from "../../graphql/mutations/chef/update_chef";
import style from "./style";
import Fab from "@material-ui/core/Fab/Fab";
import InputField from "../../components/Field";
import DinerButton from '../../components/DinerButton';
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";

const PriceSchema = Yup.object().shape({
  price: Yup.number()
    .required()
    .integer('Please enter valid Price')
    .min(50, 'Minimum price $50')
});

class Price extends React.Component {
  componentDidMount() {
    window.onload = function() {
      window.scrollTo(0, 0);
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      price: props.minEngagementPrice || ""
    };
  }

  render() {
    return (
      <div className="chef-right-col">
        <div className="schedule-head-col">
          <div className="header-step-col">
            <p className="located-text" style={style.headerText}>
              Minimum Price
            </p>
            <div className="cont-btn">
              <DinerButton />
            </div>
          </div>
        </div>
        <p style={style.subHeaderText}>
          What is your minimum engagement price?
        </p>
        <h4 align="left" style={style.textFont}>
          ENTER
        </h4>
        <Mutation mutation={UPDATE_CHEF}>
          {updateChef => (
            <Formik
              initialValues={{
                price: this.state.price
              }}
              enableReinitialize
              validationSchema={PriceSchema}
              onSubmit={this.props.onSubmit(updateChef)}
              isInitialValid={PriceSchema.isValidSync(this.state)}
            >
              {({ errors, touched, isValid, isSubmitting }) => (
                <Form>
                  <Grid container>
                    <Grid
                      item
                      md={6}
                      xs={12}
                      style={{
                        display: "flex"
                      }}
                      className="engagement-input-col"
                    >
                      <InputField
                        name={"price"}
                        placeholder={"Enter Price"}
                        error={errors.price && touched.price}
                        errorMessage={errors.price}
                        hideLabel={true}
                        type={"text"}
                        inputType={"number"}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          )
                        }}
                      />
                    </Grid>
                    <Grid item md={12} sm={12} style={{ textAlign: "right" }}>
                      <div style={style.fieldContainer}>
                        <Fab
                          id={"price-submit"}
                         data-test-id={"pricesubmit"}
                          variant={"extended"}
                          type="submit"
                          style={isValid ? style.submitButton : style.disabledSubmitButton}
                          disabled={!isValid || isSubmitting}
                        >
                          Continue
                        </Fab>
                      </div>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          )}
        </Mutation>
      </div>
    );
  }
}

export default Price;
